module.exports = __webpack_public_path__ + "img/项目挂牌.18079a55.png";